// extracted by mini-css-extract-plugin
module.exports = {"container":"navbar-module--container--16Xp2","header":"navbar-module--header--1vlsv","navbar":"navbar-module--navbar--8fnkJ","divider":"navbar-module--divider--1-ROj"};